module.exports = __webpack_public_path__ + "files/ba90c80f817be55300650b2d612db148.png";